//Call_[npm_run_updateIndexes]_to_update_this_file.

// @create-index

import _device from './device';
export const device = _device;
export default {device};

